import React from 'react'
import { useParams, Link } from 'react-router-dom'
import { Package, ArrowRight } from 'lucide-react'

const ProductCategoryPage = () => {
  const { category } = useParams()

  const products = {
    plastik: {
      title: 'Plastik Ambalaj Ürünleri',
      description: 'IML teknolojisi ile üretilen yüksek kaliteli plastik kovalar ve kutular',
      categories: [
        {
          name: 'Yuvarlak Kovalar',
          items: [
            { name: '0.5 Lt Kova', capacity: '0.5 Lt', image: 'https://eminis.com.tr/wp-content/uploads/2022/06/565-ML-5021-2-350x350.jpg' },
            { name: '1 Lt Kova', capacity: '1 Lt', image: 'https://eminis.com.tr/wp-content/uploads/2022/06/1-LT-GOuVDE-1-350x350.jpg' },
            { name: '3 Lt Kova', capacity: '3 Lt', image: 'https://eminis.com.tr/wp-content/uploads/2022/06/3-LT-GOuVDE-1-350x350.jpg' },
            { name: '3 Lt Ağır Kova', capacity: '3 Lt', image: 'https://eminis.com.tr/wp-content/uploads/2022/06/3-LT-GOuVDE-1-350x350.jpg' },
            { name: '9 Lt Kova', capacity: '9 Lt', image: 'https://eminis.com.tr/wp-content/uploads/2022/06/9-LT-GOuVDE-1-350x350.jpg' },
            { name: '9 Lt Ağır Kova', capacity: '9 Lt', image: 'https://eminis.com.tr/wp-content/uploads/2022/06/9-LT-GOuVDE-1-350x350.jpg' },
            { name: '18 Lt Kova', capacity: '18 Lt', image: 'https://eminis.com.tr/wp-content/uploads/2022/06/18-LT-GOuVDE-1-350x350.jpg' },
            { name: '18 Lt Performans Kova', capacity: '18 Lt', image: 'https://eminis.com.tr/wp-content/uploads/2022/06/18-LT-GOuVDE-1-350x350.jpg' },
            { name: '18 Lt Hafif Kova', capacity: '18 Lt', image: 'https://eminis.com.tr/wp-content/uploads/2022/06/18-LT-GOuVDE-1-350x350.jpg' },
            { name: '18 Lt Ağır Kova', capacity: '18 Lt', image: 'https://eminis.com.tr/wp-content/uploads/2022/06/18-LT-GOuVDE-1-350x350.jpg' },
            { name: '20 Lt Kova', capacity: '20 Lt', image: 'https://eminis.com.tr/wp-content/uploads/2022/06/18-LT-GOuVDE-1-350x350.jpg' }
          ]
        },
        {
          name: 'Dörtköşe Kutular',
          items: [
            { name: '0.8 Lt Kutu', capacity: '0.8 Lt', image: 'https://images.unsplash.com/photo-1594844390934-5c0c7e0b1e6f?w=400&q=80' },
            { name: '1.2 Lt Kutu', capacity: '1.2 Lt', image: 'https://images.unsplash.com/photo-1594844390934-5c0c7e0b1e6f?w=400&q=80' },
            { name: '1.5 Lt Kutu', capacity: '1.5 Lt', image: 'https://images.unsplash.com/photo-1594844390934-5c0c7e0b1e6f?w=400&q=80' }
          ]
        }
      ]
    },
    metal: {
      title: 'Metal Ambalaj Ürünleri',
      description: 'Dayanıklı ve güvenli metal kovalar, bidonlar ve kutular',
      categories: [
        {
          name: 'Silindirik Kutular',
          items: [
            { name: '73 Çap Kutu', diameter: '73mm', image: 'https://images.unsplash.com/photo-1565688534245-05d6b5be184a?w=400&q=80' },
            { name: '82 Çap Kutu', diameter: '82mm', image: 'https://images.unsplash.com/photo-1565688534245-05d6b5be184a?w=400&q=80' },
            { name: '99 Çap Kutu', diameter: '99mm', image: 'https://images.unsplash.com/photo-1565688534245-05d6b5be184a?w=400&q=80' },
            { name: '105 Çap Kutu', diameter: '105mm', image: 'https://images.unsplash.com/photo-1565688534245-05d6b5be184a?w=400&q=80' },
            { name: '108 Çap Kutu', diameter: '108mm', image: 'https://images.unsplash.com/photo-1565688534245-05d6b5be184a?w=400&q=80' },
            { name: '153 Çap Kutu', diameter: '153mm', image: 'https://images.unsplash.com/photo-1565688534245-05d6b5be184a?w=400&q=80' },
            { name: '155 Çap Kutu', diameter: '155mm', image: 'https://images.unsplash.com/photo-1565688534245-05d6b5be184a?w=400&q=80' },
            { name: '165 Çap Kutu', diameter: '165mm', image: 'https://images.unsplash.com/photo-1565688534245-05d6b5be184a?w=400&q=80' }
          ]
        },
        {
          name: 'Konik Kovalar',
          items: [
            { name: '175 Çap Kova', diameter: '175mm', image: 'https://images.unsplash.com/photo-1565688534245-05d6b5be184a?w=400&q=80' },
            { name: '180 Çap Kova', diameter: '180mm', image: 'https://images.unsplash.com/photo-1565688534245-05d6b5be184a?w=400&q=80' },
            { name: '192 Çap Kova', diameter: '192mm', image: 'https://images.unsplash.com/photo-1565688534245-05d6b5be184a?w=400&q=80' },
            { name: '220 Çap Kova', diameter: '220mm', image: 'https://images.unsplash.com/photo-1565688534245-05d6b5be184a?w=400&q=80' },
            { name: '270 Çap Kova', diameter: '270mm', image: 'https://images.unsplash.com/photo-1565688534245-05d6b5be184a?w=400&q=80' }
          ]
        },
        {
          name: 'Bidon & Monoblok',
          items: [
            { name: '73 Çap Tapalı', diameter: '73mm', image: 'https://images.unsplash.com/photo-1565688534245-05d6b5be184a?w=400&q=80' },
            { name: '82 Çap Tapalı', diameter: '82mm', image: 'https://images.unsplash.com/photo-1565688534245-05d6b5be184a?w=400&q=80' },
            { name: '99 Çap Tapalı', diameter: '99mm', image: 'https://images.unsplash.com/photo-1565688534245-05d6b5be184a?w=400&q=80' },
            { name: '99 Çap Monoblok', diameter: '99mm', image: 'https://images.unsplash.com/photo-1565688534245-05d6b5be184a?w=400&q=80' },
            { name: '105 Çap Tapalı', diameter: '105mm', image: 'https://images.unsplash.com/photo-1565688534245-05d6b5be184a?w=400&q=80' },
            { name: '108 Çap Tapalı', diameter: '108mm', image: 'https://images.unsplash.com/photo-1565688534245-05d6b5be184a?w=400&q=80' },
            { name: '153 Çap Bidon', diameter: '153mm', image: 'https://images.unsplash.com/photo-1565688534245-05d6b5be184a?w=400&q=80' },
            { name: '165 Çap Bidon', diameter: '165mm', image: 'https://images.unsplash.com/photo-1565688534245-05d6b5be184a?w=400&q=80' },
            { name: '215 Çap Bidon', diameter: '215mm', image: 'https://images.unsplash.com/photo-1565688534245-05d6b5be184a?w=400&q=80' },
            { name: '220 Çap Bidon', diameter: '220mm', image: 'https://images.unsplash.com/photo-1565688534245-05d6b5be184a?w=400&q=80' },
            { name: '270 Çap Bidon', diameter: '270mm', image: 'https://images.unsplash.com/photo-1565688534245-05d6b5be184a?w=400&q=80' },
            { name: '275 Çap Bidon', diameter: '275mm', image: 'https://images.unsplash.com/photo-1565688534245-05d6b5be184a?w=400&q=80' }
          ]
        },
        {
          name: 'UN Ambalajlar',
          items: [
            { name: '215 Çap UN Bidon', diameter: '215mm', image: 'https://images.unsplash.com/photo-1565688534245-05d6b5be184a?w=400&q=80' },
            { name: '220 Çap UN Kova', diameter: '220mm', image: 'https://images.unsplash.com/photo-1565688534245-05d6b5be184a?w=400&q=80' },
            { name: '270 Çap UN Bidon', diameter: '270mm', image: 'https://images.unsplash.com/photo-1565688534245-05d6b5be184a?w=400&q=80' },
            { name: '270 Çap UN Kova', diameter: '270mm', image: 'https://images.unsplash.com/photo-1565688534245-05d6b5be184a?w=400&q=80' },
            { name: '275 Çap UN Bidon', diameter: '275mm', image: 'https://images.unsplash.com/photo-1565688534245-05d6b5be184a?w=400&q=80' }
          ]
        }
      ]
    }
  }

  const currentCategory = products[category] || products.plastik

  return (
    <div data-component-path="client/src/pages/ProductCategoryPage.jsx" data-component-line="1:1" data-component-id="client/src/pages/ProductCategoryPage.jsx:1:1" className="min-h-screen">
      <section data-component-path="client/src/pages/ProductCategoryPage.jsx" data-component-line="2:2" data-component-id="client/src/pages/ProductCategoryPage.jsx:2:2" 
        className="relative h-96 bg-cover bg-center flex items-center"
        style={{
          backgroundImage: category === 'plastik' 
            ? 'url(https://images.unsplash.com/photo-1594844390934-5c0c7e0b1e6f?w=1600&q=80)'
            : 'url(https://images.unsplash.com/photo-1565688534245-05d6b5be184a?w=1600&q=80)'
        }}
      >
        <div data-component-path="client/src/pages/ProductCategoryPage.jsx" data-component-line="3:3" data-component-id="client/src/pages/ProductCategoryPage.jsx:3:3" className="absolute inset-0 bg-gray-900/70"></div>
        <div data-component-path="client/src/pages/ProductCategoryPage.jsx" data-component-line="4:4" data-component-id="client/src/pages/ProductCategoryPage.jsx:4:4" className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-white">
          <h1 data-component-path="client/src/pages/ProductCategoryPage.jsx" data-component-line="5:5" data-component-id="client/src/pages/ProductCategoryPage.jsx:5:5" className="text-5xl font-bold mb-4">{currentCategory.title}</h1>
          <p data-component-path="client/src/pages/ProductCategoryPage.jsx" data-component-line="6:6" data-component-id="client/src/pages/ProductCategoryPage.jsx:6:6" className="text-xl">{currentCategory.description}</p>
        </div>
      </section>

      {currentCategory.categories.map((cat, catIndex) => (
        <section data-component-path="client/src/pages/ProductCategoryPage.jsx" data-component-line="7:7" data-component-id="client/src/pages/ProductCategoryPage.jsx:7:7" key={catIndex} className="py-20 bg-white">
          <div data-component-path="client/src/pages/ProductCategoryPage.jsx" data-component-line="8:8" data-component-id="client/src/pages/ProductCategoryPage.jsx:8:8" className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <h2 data-component-path="client/src/pages/ProductCategoryPage.jsx" data-component-line="9:9" data-component-id="client/src/pages/ProductCategoryPage.jsx:9:9" className="text-3xl font-bold text-gray-900 mb-8">{cat.name}</h2>
            
            <div data-component-path="client/src/pages/ProductCategoryPage.jsx" data-component-line="10:10" data-component-id="client/src/pages/ProductCategoryPage.jsx:10:10" className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">
              {cat.items.map((product, index) => (
                <div data-component-path="client/src/pages/ProductCategoryPage.jsx" data-component-line="11:11" data-component-id="client/src/pages/ProductCategoryPage.jsx:11:11" 
                  key={index} 
                  className="bg-white rounded-xl shadow-md hover:shadow-xl transition-all duration-300 overflow-hidden group"
                >
                  <div data-component-path="client/src/pages/ProductCategoryPage.jsx" data-component-line="12:12" data-component-id="client/src/pages/ProductCategoryPage.jsx:12:12" className="relative h-64 bg-gray-100 overflow-hidden">
                    <img data-component-path="client/src/pages/ProductCategoryPage.jsx" data-component-line="13:13" data-component-id="client/src/pages/ProductCategoryPage.jsx:13:13" 
                      src={product.image} 
                      alt={product.name}
                      className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-300"
                      onError={(e) => {
                        e.target.onerror = null
                        e.target.src = 'https://images.unsplash.com/photo-1594844390934-5c0c7e0b1e6f?w=400&q=80'
                      }}
                    />
                  </div>
                  <div data-component-path="client/src/pages/ProductCategoryPage.jsx" data-component-line="14:14" data-component-id="client/src/pages/ProductCategoryPage.jsx:14:14" className="p-6">
                    <h3 data-component-path="client/src/pages/ProductCategoryPage.jsx" data-component-line="15:15" data-component-id="client/src/pages/ProductCategoryPage.jsx:15:15" className="text-lg font-semibold text-gray-900 mb-2">{product.name}</h3>
                    <p data-component-path="client/src/pages/ProductCategoryPage.jsx" data-component-line="16:16" data-component-id="client/src/pages/ProductCategoryPage.jsx:16:16" className="text-gray-600 mb-4">
                      {product.capacity && `Kapasite: ${product.capacity}`}
                      {product.diameter && `Çap: ${product.diameter}`}
                    </p>
                    <Link data-component-path="client/src/pages/ProductCategoryPage.jsx" data-component-line="17:17" data-component-id="client/src/pages/ProductCategoryPage.jsx:17:17" 
                      to="/iletisim" 
                      className="inline-flex items-center gap-2 text-blue-600 hover:text-blue-700 font-medium"
                    >
                      Teklif Al
                      <ArrowRight className="w-4 h-4" />
                    </Link>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>
      ))}

      <section data-component-path="client/src/pages/ProductCategoryPage.jsx" data-component-line="18:18" data-component-id="client/src/pages/ProductCategoryPage.jsx:18:18" className="py-20 bg-blue-600">
        <div data-component-path="client/src/pages/ProductCategoryPage.jsx" data-component-line="19:19" data-component-id="client/src/pages/ProductCategoryPage.jsx:19:19" className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center text-white">
          <Package className="w-16 h-16 mx-auto mb-6" />
          <h2 data-component-path="client/src/pages/ProductCategoryPage.jsx" data-component-line="20:20" data-component-id="client/src/pages/ProductCategoryPage.jsx:20:20" className="text-4xl font-bold mb-4">Özel Tasarım İhtiyaçlarınız İçin</h2>
          <p data-component-path="client/src/pages/ProductCategoryPage.jsx" data-component-line="21:21" data-component-id="client/src/pages/ProductCategoryPage.jsx:21:21" className="text-xl mb-8 text-blue-100">
            Ar-Ge ekibimiz ile özel ambalaj çözümleri geliştirebiliriz
          </p>
          <Link data-component-path="client/src/pages/ProductCategoryPage.jsx" data-component-line="22:22" data-component-id="client/src/pages/ProductCategoryPage.jsx:22:22" 
            to="/iletisim" 
            className="inline-flex items-center justify-center gap-2 h-14 px-8 bg-white text-blue-600 rounded-lg hover:bg-gray-100 transition-all duration-200 font-semibold shadow-lg hover:shadow-xl"
          >
            Bizimle İletişime Geçin
            <ArrowRight className="w-5 h-5" />
          </Link>
        </div>
      </section>
    </div>
  )
}

export default ProductCategoryPage